import { createContext } from 'react';

const CoreNotificationsContext = createContext({});

export default CoreNotificationsContext;
